// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1744710774476
      var cssReload = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  